var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_166_2192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 0.103882C28.6522 0.103882 31.1957 1.15745 33.0711 3.03281C34.9464 4.90818 36 7.45172 36 10.1039V26.1039C36 28.756 34.9464 31.2996 33.0711 33.1749C31.1957 35.0503 28.6522 36.1039 26 36.1039H10C7.34784 36.1039 4.8043 35.0503 2.92893 33.1749C1.05357 31.2996 0 28.756 0 26.1039V10.1039C0 7.45172 1.05357 4.90818 2.92893 3.03281C4.8043 1.15745 7.34784 0.103882 10 0.103882H26ZM18 10.1039C15.9475 10.1039 13.9735 10.8928 12.4864 12.3073C10.9992 13.7219 10.1126 15.654 10.01 17.7039L10 18.1039C10 19.6861 10.4692 21.2328 11.3482 22.5484C12.2273 23.864 13.4767 24.8894 14.9385 25.4949C16.4003 26.1004 18.0089 26.2588 19.5607 25.9502C21.1126 25.6415 22.538 24.8796 23.6569 23.7607C24.7757 22.6419 25.5376 21.2165 25.8463 19.6646C26.155 18.1128 25.9965 16.5042 25.391 15.0424C24.7855 13.5806 23.7602 12.3312 22.4446 11.4521C21.129 10.5731 19.5823 10.1039 18 10.1039ZM27 7.10388C26.5101 7.10395 26.0373 7.28379 25.6713 7.60931C25.3052 7.93483 25.0713 8.38338 25.014 8.86988L25 9.12388C25.0006 9.63364 25.1958 10.1239 25.5457 10.4946C25.8956 10.8653 26.3739 11.0884 26.8828 11.1182C27.3917 11.1481 27.8928 10.9825 28.2837 10.6554C28.6746 10.3282 28.9258 9.86407 28.986 9.35788L29 9.10388C29 8.57345 28.7893 8.06474 28.4142 7.68967C28.0391 7.3146 27.5304 7.10388 27 7.10388Z",
    fill: "#A4A7AE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_166_2192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0 0.103882)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.3c593ba0df348732bdae9a4cc892fa93.svg";
export { ForwardRef as ReactComponent };